import { Button } from "@/components/clickable";
import { VStack } from "@/components/layout";
import AuthorizeGate from "@/modules/authorize/gate";
import getPath from "@/modules/get-path";
import Header from "./header";

export default function Empty({ project, statements }) {
  if (statements.items.length > 0) return <></>;

  return (
    <>
      <VStack className="gap-3">
        <Header project={project} />
        <div className="max-w-xl">
          <p className="text-base text-zinc-600">
            This is your project folder. Upload either bank statements or credit
            card statements in PDF format.{" "}
            <a
              target="_blank"
              className="font-medium text-black underline"
              href="https://docs.counselpro.ai/en/articles/10200141-how-to-create-projects-upload-financial-documents-and-process-projects"
            >
              Read the guide.
            </a>
          </p>
        </div>
      </VStack>

      <VStack className="mt-5 h-[70%] w-full items-center justify-center gap-3.5">
        <AuthorizeGate>
          <p className="text-sm font-normal text-zinc-600">
            You have no PDF statements
          </p>
          <Button href={`${getPath(project)}/statements/new`}>
            Upload PDF statements
          </Button>
        </AuthorizeGate>
      </VStack>
    </>
  );
}
